import React, { createContext, useContext } from "react";

import { useAssistantChat } from "../hooks/useAssistantChat";
import type { AssistantChatHookReturn } from "../hooks/useAssistantChat";

// Create a context for the assistant chat
const AssistantChatContext = createContext<AssistantChatHookReturn | null>(
  null,
);

/**
 * Provider component that wraps the application to provide chat functionality
 * to both the floating assistant and full-screen assistant
 */
export const AssistantChatProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const chatHook = useAssistantChat();

  return (
    <AssistantChatContext.Provider value={chatHook}>
      {children}
    </AssistantChatContext.Provider>
  );
};

/**
 * Custom hook to use the shared assistant chat context
 * @returns The assistant chat hook return value
 */
export const useSharedAssistantChat = (): AssistantChatHookReturn => {
  const context = useContext(AssistantChatContext);

  if (!context) {
    throw new Error(
      "useSharedAssistantChat must be used within an AssistantChatProvider",
    );
  }

  return context;
};
